import { NOMINATION_STATUS } from './constants';

export const filteringTableFilterUniqueCandidates = (tableData) =>
  tableData.filter((itemOne, index, self) => {
    if (!itemOne?.candidate) return false;
    const sameCandidates = self.filter(
      (itemTwo) =>
        itemTwo?.candidate?.toLowerCase().replace(/\s+/g, ' ').trim() ===
        itemOne.candidate.toLowerCase().replace(/\s+/g, ' ').trim(),
    );
    const sameCandidatedraftNomination = sameCandidates.find(
      (item) =>
        item?.nominationStatusTypeId === NOMINATION_STATUS.DRAFT &&
        typeof item.nominationId === 'string' &&
        item.nominationId.includes('d'),
    );
    const isUniqueDraft =
      sameCandidatedraftNomination &&
      (sameCandidates.length === 1 ||
        sameCandidates.every(
          (candidate) =>
            candidate.nominationStatusTypeId === NOMINATION_STATUS.EXPIRED ||
            (candidate.nominationStatusTypeId === NOMINATION_STATUS.DRAFT &&
              typeof candidate.nominationId === 'string' &&
              candidate.nominationId.includes('d')),
        ));
    if (sameCandidatedraftNomination) {
      if (itemOne.nominationStatusTypeId === NOMINATION_STATUS.EXPIRED) {
        sameCandidatedraftNomination.roundYear = '';
        sameCandidatedraftNomination.lastConsidered = '';
      } else if (itemOne.nominationStatusTypeId !== NOMINATION_STATUS.EXPIRED) {
        sameCandidatedraftNomination.roundYear = itemOne.roundYear;
        sameCandidatedraftNomination.lastConsidered = itemOne.lastConsidered;
      }
      if (isUniqueDraft) {
        sameCandidatedraftNomination.roundYear = 'New';
      }
    }
    if (
      sameCandidatedraftNomination &&
      itemOne.nominationStatusTypeId === NOMINATION_STATUS.SUBMITTED
    ) {
      return false;
    }
    if (
      sameCandidatedraftNomination &&
      itemOne.nominationStatusTypeId === NOMINATION_STATUS.DRAFT &&
      (typeof itemOne.nominationId !== 'string' ||
        !itemOne.nominationId.includes('d'))
    ) {
      return false;
    }
    return true;
  });
